<template>
  <div id="heuresgestion">
    <router-link to="/heures">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Gestion des heures</h2>
    <label for="enddate">Date</label>
    <button @click="changeDate(false)" class="btn">
      <font-awesome-icon :icon="'arrow-left'" />
    </button>
    <date-picker
      class="ml-3"
      type="date"
      format="dd DD/MM/YYYY"
      v-model="date"
      @change="loadHeures"
    />
    <button @click="changeDate(true)" class="btn">
      <font-awesome-icon :icon="'arrow-right'" />
    </button>
    <button class="btn btn-success ml-3 btn-sm" @click="save()">
      <font-awesome-icon :icon="'check'" />&nbsp;Enregistrer les modifications
    </button>
    <button
      :style="isPreviousDay ? '' : 'cursor: not-allowed'"
      :disabled="!isPreviousDay"
      class="btn btn-primary ml-3 btn-sm"
      @click="generate()"
    >
      Générer les heures du jour
    </button>
    <div v-for="site of sites" :key="site.id">
      <h2>{{ site.nom }}</h2>
      <div class="table-responsive">
        <table width="100%" class="mt-3 table table-hover">
          <thead>
            <tr>
              <th width="15%">Employé</th>
              <th width="15%">Fonction</th>
              <th width="10%">A1-D1</th>
              <th width="10%">A2-D2</th>
              <th width="10%">A3-D3</th>
              <th width="10%">A4-D4</th>
              <th width="10%">A5-D5</th>
              <th width="10%">A6-D6</th>
              <th width="10%">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="heure of heures.filter((heure) => {
                return heure.id_site === site.id;
              })"
              v-bind:key="heure.id"
            >
              <th scope="row">
                <div class="form-group">
                  <select class="custom-select" v-model="heure.id_employe">
                    <option :value="undefined">Sélectionner un employé</option>
                    <option
                      v-for="employe of employes"
                      :key="employe.id"
                      :value="employe.id"
                    >
                      {{ employe.acronyme }} - {{ employe.nom }}
                      {{ employe.prenom }}
                    </option>
                  </select>
                </div>
              </th>
              <td>
                <div class="form-group">
                  <select class="custom-select" v-model="heure.id_fonction">
                    <option :value="undefined">
                      Sélectionner une fonction
                    </option>
                    <option
                      v-for="fonction of fonctions"
                      :key="fonction.id"
                      :value="fonction.id"
                    >
                      {{ fonction.nom }}
                    </option>
                  </select>
                </div>
              </td>
              <td>
                <div class="form-inline">
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.a1)"
                      maxlength="2"
                      v-model="heure.a1"
                      style="width: 40px"
                    />
                    .
                    <input
                      onfocus="this.select();"
                      style="width: 40px"
                      type="text"
                      maxlength="2"
                      v-model="heure.a1_2"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.d1)"
                      maxlength="2"
                      v-model="heure.d1"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.d1_2"
                    />
                  </div>
                </div>
              </td>
              <td>
                <div class="form-inline">
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.a2)"
                      maxlength="2"
                      v-model="heure.a2"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.a2_2"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.d2)"
                      maxlength="2"
                      v-model="heure.d2"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.d2_2"
                    />
                  </div>
                </div>
              </td>
              <td>
                <div class="form-inline">
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.a3)"
                      maxlength="2"
                      v-model="heure.a3"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.a3_2"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.d3)"
                      maxlength="2"
                      v-model="heure.d3"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.d3_2"
                    />
                  </div>
                </div>
              </td>
              <td>
                <div class="form-inline">
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.a4)"
                      maxlength="2"
                      v-model="heure.a4"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.a4_2"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.d4)"
                      maxlength="2"
                      v-model="heure.d4"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.d4_2"
                    />
                  </div>
                </div>
              </td>
              <td>
                <div class="form-inline">
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.a5)"
                      maxlength="2"
                      v-model="heure.a5"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.a5_2"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.d5)"
                      maxlength="2"
                      v-model="heure.d5"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.d5_2"
                    />
                  </div>
                </div>
              </td>
              <td>
                <div class="form-inline">
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.a6)"
                      maxlength="2"
                      v-model="heure.a6"
                      style="width: 40px"
                    />
                    .
                    <input
                      onfocus="this.select();"
                      style="width: 40px"
                      type="text"
                      maxlength="2"
                      v-model="heure.a6_2"
                    />
                  </div>
                  <div class="form-group">
                    <input
                      onfocus="this.select();"
                      type="text"
                      v-on:keyup="onChange($event, heure.d6)"
                      maxlength="2"
                      v-model="heure.d6"
                      style="width: 40px"
                    />
                    .
                    <input
                      style="width: 40px"
                      onfocus="this.select();"
                      type="text"
                      maxlength="2"
                      v-model="heure.d6_2"
                    />
                  </div>
                </div>
              </td>
              <td>
                <button class="btn btn-danger" @click="delRow(heure)">
                  <font-awesome-icon :icon="'trash'" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button class="btn btn-success mt-3 btn-sm" @click="addRow(site.id)">
        <font-awesome-icon :icon="'plus'" />&nbsp;Ajouter une ligne
      </button>
      <hr />
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import api from "@/api";
import utils from "@/utils";
import moment from "moment";
import DatePicker from "vue2-datepicker";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  data() {
    return {
      date: new Date(moment().subtract(1, "day").format("YYYY-MM-DD")),
      sites: [],
      employes: [],
      employesById: [],
      fonctions: [],
      heures: [],
    };
  },
  components: { DatePicker },
  async created() {
    this.fetchHeures();
    let durationa = moment.duration(23.33, "hours");
    console.log(
      moment(
        `1970-01-01 ${durationa.hours()}:${durationa.minutes()}:${durationa.seconds()}`
      ).format("HH:mm:ss")
    );
    this.oldDate = this.date;
    this.sites = (await api.getSites()).data.sites;
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.fonctions = (await api.getFonctions(true)).data.fonctions;
  },
  methods: {
    async fetchHeures() {
      this.$store.commit("setLoading", true);
      this.heures = (
        await api.getHeuresByDate(moment(this.date).format("YYYY-MM-DD"))
      ).data.heures;
      for (let heure of this.heures) {
        for (let i = 0; i < 6; i++) {
          let a = String(moment.duration(heure[`a${i + 1}`]).asHours()).split(
            "."
          );
          //  let a = heure[`a${i + 1}`].split(":");
          heure[`a${i + 1}`] = a[0];
          heure[`a${i + 1}_2`] = a[1] || "0";
          let d = String(moment.duration(heure[`d${i + 1}`]).asHours()).split(
            "."
          );
          //  let d = heure[`d${i + 1}`].split(":");
          heure[`d${i + 1}`] = d[0];
          heure[`d${i + 1}_2`] = d[1] || "0";
        }
      }
      this.oldHeures = JSON.stringify(this.heures);
      this.$store.commit("setLoading", false);
    },
    async loadHeures() {
      let ok = false;
      if (this.oldHeures !== JSON.stringify(this.heures)) {
        await Swal.fire({
          title: "Attention !",
          text: `Les modifications effectuées pour le ${utils.toPrettyDate(
            this.oldDate
          )} ne seront pas enregistrées`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Annuler",
          confirmButtonText: "Continuer",
        }).then((result) => {
          if (result.value) {
            ok = true;
          }
        });
      } else {
        ok = true;
      }
      if (ok) {
        this.fetchHeures();
        this.oldDate = this.date;
      } else {
        this.date = this.oldDate;
      }
    },
    addRow(site) {
      this.heures.push({
        id_site: site,
        id_fonction: undefined,
        id_employe: undefined,
        date: this.date,
        a1: "0",
        a1_2: "0",
        d1: "0",
        d1_2: "0",
        a2: "0",
        a2_2: "0",
        d2: "0",
        d2_2: "0",
        a3: "0",
        a3_2: "0",
        d3: "0",
        d3_2: "0",
        a4: "0",
        a4_2: "0",
        d4: "0",
        d4_2: "0",
        a5: "0",
        a5_2: "0",
        d5: "0",
        d5_2: "0",
        a6: "0",
        a6_2: "0",
        d6: "0",
        d6_2: "0",
      });
    },
    delRow(heure) {
      this.heures.splice(this.heures.indexOf(heure), 1);
    },
    async save() {
      if (this.oldHeures !== JSON.stringify(this.heures)) {
        let message = undefined;
        for (let heure of this.heures) {
          if (!heure.id_employe) {
            message = "Certains employés ne sont pas indiqués";
            break;
          }
          if (!heure.id_fonction) {
            message = "Certaines fonctions ne sont pas indiquées";
          }
        }
        if (message) {
          Swal.fire({
            text: message,
            type: `error`,
          });
        } else {
          for (let heure of this.heures) {
            let allZero = true;
            for (let i = 0; i <= 6; i++) {
              //A
              if (!(isNaN(heure[`a${i}`]) || heure[`a${i}`] === "")) {
                if (Number(heure[`a${i}`]) < 0) heure[`a${i}`] = "00";
                if (Number(heure[`a${i}`]) > 23) heure[`a${i}`] = "23";
              } else {
                heure[`a${i}`] = "00";
              }
              if (!(isNaN(heure[`a${i}_2`]) || heure[`a${i}_2`] === "")) {
                if (Number(heure[`a${i}_2`]) < 0) heure[`a${i}_2`] = "00";
              } else {
                heure[`a${i}_2`] = "00";
              }
              //On teste si l'heure est égale à 16 car pour des raisons inconnues 16.33 ne donne pas le même nombre de seconde que x.33 ou x =/= 16
              let durationa;
              if (heure[`a${i}`] === "16") {
                durationa = moment.duration(
                  parseFloat(`15.${heure[`a${i}_2`]}`),
                  "hours"
                );
                heure[`a${i}`] = moment(
                  `1970-01-01 16:${durationa.minutes()}:${durationa.seconds()}`
                ).format("HH:mm:ss");
              } else {
                durationa = moment.duration(
                  parseFloat(`${heure[`a${i}`]}.${heure[`a${i}_2`]}`),
                  "hours"
                );
                heure[`a${i}`] = moment(
                  `1970-01-01 ${durationa.hours()}:${durationa.minutes()}:${durationa.seconds()}`
                ).format("HH:mm:ss");
              }
              allZero = allZero ? heure[`a${i}`] === "00:00:00" : false;
              //D
              if (!(isNaN(heure[`d${i}`]) || heure[`d${i}`] === "")) {
                if (Number(heure[`d${i}`]) < 0) heure[`d${i}`] = "00";
                if (Number(heure[`d${i}`]) > 23) heure[`d${i}`] = "23";
              } else {
                heure[`d${i}`] = "00";
              }
              if (!(isNaN(heure[`d${i}_2`]) || heure[`d${i}_2`] === "")) {
                if (Number(heure[`d${i}_2`]) < 0) heure[`d${i}_2`] = "00";
              } else {
                heure[`d${i}_2`] = "00";
              }
              //On teste si l'heure est égale à 16 car pour des raisons inconnues 16.33 ne donne pas le même nombre de seconde que x.33 ou x =/= 16
              let durationd;
              if (heure[`d${i}`] === "16") {
                durationd = moment.duration(
                  parseFloat(`15.${heure[`d${i}_2`]}`),
                  "hours"
                );
                heure[`d${i}`] = moment(
                  `1970-01-01 16:${durationd.minutes()}:${durationd.seconds()}`
                ).format("HH:mm:ss");
              } else {
                durationd = moment.duration(
                  parseFloat(`${heure[`d${i}`]}.${heure[`d${i}_2`]}`),
                  "hours"
                );
                heure[`d${i}`] = moment(
                  `1970-01-01 ${durationd.hours()}:${durationd.minutes()}:${durationd.seconds()}`
                ).format("HH:mm:ss");
              }

              allZero = allZero ? heure[`d${i}`] === "00:00:00" : false;
            }
            if (allZero) {
              await Swal.fire({
                type: "warning",
                title: "Attention",
                text: `Les heures de ${
                  this.employesById[heure.id_employe].nom
                } ${this.employesById[heure.id_employe].prenom} sont vides!`,
              });
            }
          }
          let response = await api.updateHeuresByDate(
            this.heures,
            moment(this.date).format("YYYY-MM-DD")
          );
          Toast.fire({
            type: response.code === 200 ? "success" : "error",
            text: response.message,
          });
          this.fetchHeures();
        }
      }
    },
    onChange(e, data) {
      if (e.which !== 9) {
        // 9 => TAB
        if (data.length >= 2) {
          e.target.nextElementSibling.focus();
        }
      }
    },
    async generate() {
      this.$store.commit("setLoading", true);
      let response = await api.generateHours(
        moment(this.date).format("YYYY-MM-DD")
      );
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message,
      });
      if (response.code === 200) {
        this.loadHeures();
      }
      this.$store.commit("setLoading", false);
    },
    changeDate(forwards, date) {
      if (date) {
        this.date = new Date(date);
      } else {
        if (forwards) {
          this.date = new Date(
            moment(this.date).add(1, "d").format("YYYY-MM-DD")
          );
        } else {
          this.date = new Date(
            moment(this.date).subtract(1, "d").format("YYYY-MM-DD")
          );
        }
      }
      this.loadHeures();
    },
  },
  computed: {
    isPreviousDay() {
      return moment().isAfter(this.date, "day");
    },
  },
};
</script>